import _toConsumableArray from "/zeit/2165d465/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import "core-js/modules/es6.string.starts-with";
import "core-js/modules/es7.array.includes";
import "core-js/modules/es6.string.includes";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.function.name";
import "core-js/modules/es6.regexp.to-string";
import _defineProperty from "/zeit/2165d465/node_modules/@babel/runtime/helpers/esm/defineProperty";
import "core-js/modules/es6.object.assign";
import _slicedToArray from "/zeit/2165d465/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es7.object.entries";
import * as React from 'react';
import { createContext, useState as useState$1, useMemo, createElement, useContext, useCallback, useRef, useEffect } from 'react';
import { Animate } from 'react-simple-animate';
var STORE_DEFAULT_NAME = '__STATE_MACHINE__';
var STATE_MACHINE_DEBUG_NAME = '___STATE_MACHINE_DEBUG__';
var STATE_MACHINE_DEV_TOOL_CONFIG = '___STATE_MACHINE_DEV_CONFIG__';
var COLORS = {
  primary: '#0a1c2c',
  secondary: 'rgb(17, 50, 76)'
};
var Z_INDEX = {
  top: 100000000,
  second: 99999999
};

var getBrowserStoreData = function getBrowserStoreData(storageType, storeName) {
  var sessionStorageData = storageType.getItem(storeName);

  try {
    return sessionStorageData ? JSON.parse(sessionStorageData) : undefined;
  } catch (_a) {
    return undefined;
  }
};

function storeFactory(storageType, name) {
  var storeName = name || STORE_DEFAULT_NAME;
  var store = getBrowserStoreData(storageType, storeName);

  var getName = function getName() {
    return storeName;
  };

  var set = function set(value) {
    store = value;
  };

  var get = function get() {
    return store;
  };

  return {
    set: set,
    get: get,
    getName: getName
  };
}

function setUpDevTools(isDevMode, storageType, getName, getStore) {
  if (typeof window === 'undefined' || !isDevMode) return; // @ts-ignore

  window['STATE_MACHINE_DEBUG'] = function (value) {
    return storageType.setItem(STATE_MACHINE_DEBUG_NAME, value);
  }; // @ts-ignore


  window['STATE_MACHINE_RESET'] = function () {
    return storageType.clear();
  }; // @ts-ignore


  window['STATE_MACHINE_GET_STORE'] = function () {
    return storageType.getItem(getName());
  }; // @ts-ignore


  window['STATE_MACHINE_SAVE_TO'] = function (name) {
    return window.localStorage.setItem(name, JSON.stringify(getStore()));
  }; // @ts-ignore


  window['STATE_MACHINE_LOAD'] = function (_ref) {
    var storeName = _ref.storeName,
        data = _ref.data;
    return storageType.setItem(getName() || STATE_MACHINE_DEBUG_NAME, data || window.localStorage.getItem(storeName) || '');
  };
}

var StateMachineContext = createContext({
  store: {},
  updateStore: function updateStore(payload) {
    return payload;
  }
});

var transform = require('lodash.transform');

var isEqual = require('lodash.isequal');

var isObject = require('lodash.isobject');

function difference(object, base) {
  function changes(object, base) {
    return transform(object, function (result, value, key) {
      if (!isEqual(value, base[key])) {
        result[key] = isObject(value) && isObject(base[key]) ? changes(value, base[key]) : value;
      }
    });
  }

  return changes(object, base);
}

var cloneDeep = require('lodash.clonedeep');

function logStartAction(_ref2) {
  var debugName = _ref2.debugName,
      getStore = _ref2.getStore;
  var storeCopy = cloneDeep(getStore());
  console.log('┌───────────────────────────────────────>');
  console.log("\u251C\u2500%c".concat(debugName), 'color: #bada55');
  console.log('├─before:', storeCopy);
  return storeCopy;
}

function logEndAction(_ref3) {
  var getStore = _ref3.getStore,
      storeCopy = _ref3.storeCopy;

  var isEmpty = require('lodash.isempty');

  var diff = difference(getStore(), storeCopy);
  var noChange = isEmpty(diff);
  console.log(noChange ? '└─after' : '├─after:', getStore());

  if (!noChange) {
    console.log('└─diff:', difference(storeCopy, getStore()), ' → ', difference(getStore(), storeCopy));
  }
}

function getSyncStoreData(defaultStoreData, options, storageType) {
  var store = defaultStoreData;
  var syncStoreOption = options.syncStores;
  if (!syncStoreOption) return store;

  try {
    if (syncStoreOption.externalStoreName && typeof syncStoreOption.transform === 'function' && typeof syncStoreOption.externalStoreName === 'string') {
      return syncStoreOption.transform({
        externalStoreData: getBrowserStoreData(storageType, syncStoreOption.externalStoreName),
        currentStoreData: store
      });
    } else {
      Object.entries(syncStoreOption).forEach(function (_ref4) {
        var _ref5 = _slicedToArray(_ref4, 2),
            key = _ref5[0],
            values = _ref5[1];

        var browserStore = getBrowserStoreData(storageType, key);
        values.forEach(function (value) {
          store = Object.assign(Object.assign({}, store), _defineProperty({}, value, Object.assign(Object.assign({}, store[value]), browserStore[value])));
        });
      });
    }
  } catch (_a) {
    return store;
  }

  return store;
}

var action;
var storageType = typeof window === 'undefined' ? {
  getItem: function getItem(payload) {
    return payload;
  },
  setItem: function setItem(payload) {
    return payload;
  },
  clear: function clear() {},
  length: 0,
  key: function key(payload) {
    return payload.toString();
  },
  removeItem: function removeItem() {}
} : window.sessionStorage;
var getStore;
var setStore;
var getName;
var middleWaresBucket = [];
var isDevMode = process.env.NODE_ENV !== 'production';

var middleWare = function middleWare(data) {
  if (data) action = data;
  return action;
};

function setStorageType(type) {
  storageType = type;
}

function createStore(defaultStoreData) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
    name: STORE_DEFAULT_NAME,
    middleWares: [],
    syncStores: undefined
  };
  var storeName = options ? options.name : STORE_DEFAULT_NAME;
  var methods = storeFactory(storageType, storeName);

  if (isDevMode) {
    // @ts-ignore
    window['STATE_MACHINE_NAME'] = storeName;
  }

  getName = methods.getName;
  getStore = methods.get;
  setStore = methods.set;
  middleWaresBucket = options.middleWares;
  setUpDevTools(isDevMode, storageType, getName, getStore);
  setStore(getSyncStoreData(getStore() || defaultStoreData, options, storageType));
}

function StateMachineProvider(props) {
  var _useState$ = useState$1(getStore()),
      _useState$2 = _slicedToArray(_useState$, 2),
      globalState = _useState$2[0],
      updateStore = _useState$2[1];

  var value = useMemo(function () {
    return {
      store: globalState,
      updateStore: updateStore
    };
  }, [globalState]); // @ts-ignore

  return createElement(StateMachineContext.Provider, Object.assign({
    value: value
  }, props));
}

var actionTemplate = function actionTemplate(_ref6) {
  var options = _ref6.options,
      callback = _ref6.callback,
      key = _ref6.key,
      updateStore = _ref6.updateStore;
  return function (payload) {
    var isDebugOn;
    var storeCopy;
    var debugName = options && (options.debugName || options.debugNames) ? key && options.debugNames ? options.debugNames[key] : options.debugName : '';

    if (isDevMode) {
      isDebugOn = storageType.getItem(STATE_MACHINE_DEBUG_NAME) === 'true';

      if (isDebugOn) {
        storeCopy = logStartAction({
          debugName: debugName || '',
          getStore: getStore
        });
      }

      middleWare({
        debugName: debugName || ''
      });
    }

    setStore(callback && callback(getStore(), payload));
    storageType.setItem(getName(), JSON.stringify(getStore()));

    if (options === undefined || options && options.shouldReRenderApp !== false) {
      updateStore(Array.isArray(middleWaresBucket) && middleWaresBucket.length ? middleWaresBucket.forEach(function (callback) {
        callback(getStore());
      }) : getStore());
    }

    if (isDevMode && isDebugOn) {
      logEndAction({
        getStore: getStore,
        storeCopy: storeCopy
      });
    }
  };
};

function useStateMachine(updateStoreFunction, options) {
  var _useContext = useContext(StateMachineContext),
      globalState = _useContext.store,
      updateStore = _useContext.updateStore;

  if (updateStoreFunction && Object.keys(updateStoreFunction).length) {
    return {
      actions: updateStoreFunction ? Object.entries(updateStoreFunction).reduce(function (previous, _ref7) {
        var _ref8 = _slicedToArray(_ref7, 2),
            key = _ref8[0],
            callback = _ref8[1];

        return Object.assign(Object.assign({}, previous), _defineProperty({}, key, useCallback(actionTemplate({
          options: options,
          callback: callback,
          updateStore: updateStore,
          key: key
        }), [])));
      }, {}) : {},
      action: function action() {},
      state: globalState
    };
  }

  return {
    actions: {},
    action: useCallback(updateStoreFunction ? actionTemplate({
      options: options,
      callback: updateStoreFunction,
      updateStore: updateStore
    }) : function () {}, []),
    state: globalState
  };
}

function saveSetting(setting) {
  try {
    var _config = window.localStorage.getItem(STATE_MACHINE_DEV_TOOL_CONFIG);

    window.localStorage.setItem(STATE_MACHINE_DEV_TOOL_CONFIG, _config ? JSON.stringify(Object.assign(Object.assign({}, JSON.parse(_config)), setting)) : JSON.stringify(setting));
  } catch (_a) {}
}

var DevToolActionPanel = function DevToolActionPanel(_ref9) {
  var setStateIndex = _ref9.setStateIndex,
      stateIndex = _ref9.stateIndex,
      actions = _ref9.actions,
      config = _ref9.config;

  var _useState$3 = useState$1(config.filterAction),
      _useState$4 = _slicedToArray(_useState$3, 2),
      filterName = _useState$4[0],
      setFilterName = _useState$4[1];

  return createElement("div", {
    style: {
      borderRight: '1px solid #11324c'
    }
  }, createElement("p", {
    style: {
      color: 'white',
      fontSize: 13,
      lineHeight: '20px',
      margin: 0,
      padding: '10px 10px 9px',
      borderBottom: "1px solid ".concat(COLORS.secondary)
    }
  }, createElement("span", {
    style: {
      fontSize: 10
    }
  }, "\u25BC"), " Actions"), createElement("input", {
    name: "filter",
    type: "search",
    style: {
      borderRadius: 0,
      background: '#11334c',
      marginTop: 0,
      border: 'none',
      color: 'white',
      padding: '10px 10px',
      width: '100%',
      boxSizing: 'border-box',
      fontSize: '14px'
    },
    defaultValue: config.filterAction,
    onChange: function onChange(event) {
      setFilterName(event.target.value.toLowerCase());
      saveSetting({
        filterAction: event.target.value
      });
    },
    placeholder: "Filter..."
  }), createElement("ul", {
    style: {
      listStyle: 'none',
      padding: 0,
      margin: 0,
      height: 'calc(100vh - 50px)',
      overflowY: 'auto'
    }
  }, actions.filter(function (data) {
    return data.name && data.name.toLowerCase && data.name.toLowerCase().includes(filterName) || !data.name && !filterName || filterName === '';
  }).map(function (_ref10, index) {
    var name = _ref10.name;
    return createElement("li", {
      style: {
        fontSize: 13,
        padding: 0
      },
      key: "".concat(name).concat(index)
    }, createElement("button", {
      style: {
        margin: 0,
        padding: 10,
        background: 'none',
        color: 'white',
        border: 'none',
        display: 'block',
        width: '100%',
        textAlign: 'left',
        borderRadius: 0,
        borderBottom: stateIndex === index ? '1px solid #ec5990' : "1px solid ".concat(COLORS.secondary),
        textTransform: 'initial'
      },
      onClick: function onClick() {
        setStateIndex(index);
      }
    }, name || 'unknown'));
  })));
};

function DevToolStorage(_ref11) {
  var setLoadPanel = _ref11.setLoadPanel;
  return createElement("div", {
    style: {
      color: 'white',
      position: 'absolute',
      top: 40,
      right: 0,
      width: 450,
      margin: 0,
      padding: 10,
      background: COLORS.primary,
      fontSize: 12,
      boxSizing: 'border-box',
      zIndex: Z_INDEX.second,
      overflowY: 'auto',
      height: 'calc(100vh - 50px)',
      overflowX: 'hidden'
    }
  }, createElement("ul", {
    style: {
      padding: 0,
      margin: 0,
      listStyle: 'none',
      fontSize: 14,
      lineHeight: 1.5
    }
  }, Object.entries(window.localStorage).map(function (_ref12, index) {
    var _ref13 = _slicedToArray(_ref12, 2),
        key = _ref13[0],
        value = _ref13[1];

    return createElement("li", {
      key: "".concat(key).concat(index)
    }, createElement("button", {
      style: {
        padding: 10,
        margin: '0 0 20px',
        width: '100%',
        textAlign: 'left',
        background: 'none',
        color: 'white',
        border: "1px solid ".concat(COLORS.secondary),
        overflowWrap: 'break-word'
      },
      onClick: function onClick() {
        if (window.confirm('Are you sure to load state?')) {
          window.sessionStorage.setItem( // @ts-ignore
          window['STATE_MACHINE_NAME'], value);
        }
      }
    }, key));
  })), createElement("button", {
    style: {
      margin: 0,
      borderRadius: '4px',
      padding: '10px',
      width: '100%'
    },
    onClick: function onClick() {
      return setLoadPanel(false);
    }
  }, "Go Back"));
}

function drillData(originalData, keys) {
  var data = originalData;
  var tempData;

  for (var key in keys) {
    tempData = data;
    var result = data[keys[key]];

    if (result && Array.isArray(result) && !result.length || typeof result === 'object' && !Object.keys(result).length || result === '') {
      delete tempData[keys[key]];
    }
  }
}

function search(data, find) {
  var keys = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
  var originalData = arguments.length > 3 ? arguments[3] : undefined;
  if (!originalData) originalData = data;

  for (var key in data) {
    var result = data[key];
    var lowerCaseKey = key.toLowerCase();
    var findLowerCase = find.toLowerCase();
    if (lowerCaseKey === findLowerCase || lowerCaseKey.startsWith(findLowerCase) || lowerCaseKey.includes(findLowerCase)) ;else if (Array.isArray(result)) {
      delete data[key];
    } else if (typeof result === 'object') {
      search(result, find, [].concat(_toConsumableArray(keys || []), [key]), originalData);
    } else {
      delete data[key];
      drillData(originalData, keys);
    }
  }

  return data;
}

var clone = require('lodash.clonedeep');

var ReactJson = function ReactJson(props) {
  return createElement("div", Object.assign({}, props));
};

if (typeof window !== 'undefined') {
  ReactJson = require('react-json-view').default;
}

var buttonStyle = {
  margin: '0 10px 0 0',
  padding: '5px 10px',
  display: 'inline',
  fontSize: '12px',
  border: 'none',
  borderRadius: '2px'
};
var toggleStyle = {
  borderRadius: 0,
  display: 'inline',
  padding: 0,
  margin: 0,
  width: 20,
  height: 20,
  top: 0,
  marginRight: 10,
  border: 0
};

var DevToolStateTree = function DevToolStateTree(_ref14) {
  var setPanel = _ref14.setPanel,
      isLoadPanelShow = _ref14.isLoadPanelShow,
      setLoadPanel = _ref14.setLoadPanel,
      state = _ref14.state,
      setExpand = _ref14.setExpand,
      isCollapse = _ref14.isCollapse,
      closePanel = _ref14.closePanel,
      stateIndex = _ref14.stateIndex,
      actions = _ref14.actions,
      config = _ref14.config,
      panelPosition = _ref14.panelPosition;

  var collapse = function collapse() {
    var expandValue = !isCollapse;
    setExpand(expandValue);
    saveSetting({
      isCollapse: expandValue
    });
  };

  var _useState$5 = useState$1(config.searchTerm),
      _useState$6 = _slicedToArray(_useState$5, 2),
      filterValue = _useState$6[0],
      setFilterValue = _useState$6[1];

  var data = ((stateIndex === -1 ? actions[actions.length - 1] : actions[stateIndex]) || {}).state;
  if (filterValue) data = search(clone(data), filterValue);
  return createElement("section", null, isLoadPanelShow && createElement(DevToolStorage, {
    setLoadPanel: setLoadPanel
  }), createElement("h3", {
    style: {
      fontWeight: 'lighter',
      color: 'white',
      fontSize: 12,
      padding: 10,
      lineHeight: '20px',
      margin: '0 0 10px 0',
      borderBottom: "1px solid ".concat(COLORS.secondary)
    }
  }, "\u2646 Little State Machine", createElement("span", {
    style: {
      marginRight: 20,
      float: 'right',
      display: 'flex'
    }
  }, createElement("button", {
    onClick: function onClick() {
      setPanel('right');
      saveSetting({
        panelPosition: 'right'
      });
    },
    style: Object.assign(Object.assign({}, toggleStyle), {
      borderRight: '6px solid #ec5990'
    })
  }), createElement("button", {
    onClick: function onClick() {
      setPanel('bottom');
      saveSetting({
        panelPosition: 'bottom'
      });
    },
    style: Object.assign(Object.assign({}, toggleStyle), {
      borderBottom: '6px solid #ec5990'
    })
  }))), createElement("section", {
    style: {
      marginLeft: 10
    }
  }, createElement("button", {
    onClick: function onClick() {
      var name = prompt('💁🏻‍♀️ Give it a name.');

      if (name) {
        window.localStorage.setItem(name, JSON.stringify(state));
      }
    },
    style: buttonStyle
  }, "Save"), createElement("button", {
    style: buttonStyle,
    onClick: function onClick() {
      return setLoadPanel(!isLoadPanelShow);
    }
  }, "Load"), createElement("button", {
    style: buttonStyle,
    onClick: function onClick() {
      collapse();
    }
  }, isCollapse ? 'Expand' : 'Collapse'), createElement("button", {
    style: buttonStyle,
    onClick: function onClick() {
      // @ts-ignore
      window.STATE_MACHINE_RESET();
    }
  }, "Reset")), createElement("button", {
    style: {
      color: 'white',
      position: 'absolute',
      top: -5,
      right: 0,
      padding: 10,
      appearance: 'none',
      background: 'none',
      fontSize: 26,
      border: 0,
      margin: 0,
      lineHeight: '22px'
    },
    "aria-label": "close panel",
    onClick: function onClick() {
      if (isLoadPanelShow) {
        setLoadPanel(false);
      } else {
        closePanel();
      }
    }
  }, "\xD7"), createElement("section", {
    style: {
      padding: '10px 0px 10px 10px'
    }
  }, createElement("input", {
    name: "filter",
    style: {
      borderRadius: 0,
      background: '#11334c',
      marginTop: 10,
      border: 0,
      color: 'white',
      padding: '10px 10px',
      boxSizing: 'border-box',
      fontSize: '14px',
      width: 'calc(100% + 10px)',
      margin: '0 -10px 10px'
    },
    type: "search",
    placeholder: "Search...",
    defaultValue: config.searchTerm,
    onChange: function onChange(e) {
      setFilterValue(e.target.value);
      saveSetting({
        searchTerm: e.target.value
      });
    }
  }), createElement(ReactJson, {
    src: data,
    theme: "harmonic",
    iconStyle: "square",
    enableClipboard: false,
    collapsed: isCollapse,
    displayObjectSize: false,
    displayDataTypes: false,
    indentWidth: 2,
    style: {
      fontSize: 12,
      overflow: 'auto',
      height: !panelPosition || panelPosition === 'right' ? "calc(".concat(window.screen.height - 275, "px)") : "calc(".concat(window.innerHeight * 0.4 - 140, "px)")
    }
  })));
};

var cloneDeep$1 = require('lodash.clonedeep');

var useState = React.useState;
var actions = [];
var previousStateIndex = -1;
var previousIsLoadPanelShow = false;
var config = typeof window !== 'undefined' ? // @ts-ignore
JSON.parse(window.localStorage.getItem(STATE_MACHINE_DEV_TOOL_CONFIG) || '{"isCollapse": false, "isClose": true}') : {
  isCollapse: false,
  isClose: true,
  searchTerm: '',
  filterAction: '',
  panelPosition: 'right',
  mouseMoveDiff: 0
};
var previousMouseMoveDiff = config.mouseMoveDiff;
var previousIsCollapse = config.isCollapse;
var previousIsClose = config.isClose;

var DevTool = function DevTool(_ref15) {
  var iconSize = _ref15.iconSize;

  var _useStateMachine = useStateMachine(),
      state = _useStateMachine.state;

  var _useState = useState(config.isClose),
      _useState2 = _slicedToArray(_useState, 2),
      isClose = _useState2[0],
      setClose = _useState2[1];

  var _useState3 = useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      isLoadPanelShow = _useState4[0],
      setLoadPanel = _useState4[1];

  var _useState5 = useState(config.isCollapse),
      _useState6 = _slicedToArray(_useState5, 2),
      isCollapse = _useState6[0],
      setExpand = _useState6[1];

  var _useState7 = useState(-1),
      _useState8 = _slicedToArray(_useState7, 2),
      stateIndex = _useState8[0],
      setStateIndex = _useState8[1];

  var _useState9 = useState(config.panelPosition),
      _useState10 = _slicedToArray(_useState9, 2),
      panelPosition = _useState10[0],
      setPanel = _useState10[1];

  var rootRef = useRef(null);
  var mouseDownOriginalX = useRef(0);

  var _useState11 = useState(config.mouseMoveDiff),
      _useState12 = _slicedToArray(_useState11, 2),
      mouseMoveDiff = _useState12[0],
      setMouseMoveDiff = _useState12[1];

  var closePanel = function closePanel() {
    var closeValue = !isClose;
    setClose(closeValue);
    saveSetting({
      isClose: closeValue
    });
  };

  if (previousStateIndex === stateIndex && previousIsClose === isClose && previousIsLoadPanelShow === isLoadPanelShow && previousIsCollapse === isCollapse && previousMouseMoveDiff === mouseMoveDiff) {
    actions.push({
      name: (middleWare() || {}).debugName,
      state: cloneDeep$1(state)
    });
  }

  previousStateIndex = stateIndex;
  previousIsClose = isClose;
  previousIsLoadPanelShow = isLoadPanelShow;
  previousIsCollapse = isCollapse;
  previousMouseMoveDiff = mouseMoveDiff;

  var move = function move(e) {
    setMouseMoveDiff(e.clientX - mouseDownOriginalX.current);
  };

  var mouseup = function mouseup(e) {
    if (rootRef && rootRef.current) {
      rootRef.current.style.userSelect = 'auto';
    }

    saveSetting({
      mouseMoveDiff: e.clientX - mouseDownOriginalX.current
    });
    document.removeEventListener('mousemove', move);
  };

  var onMouseDown = function onMouseDown(e) {
    if (rootRef && rootRef.current) {
      rootRef.current.style.userSelect = 'none';
    }

    mouseDownOriginalX.current = e.clientX;
    document.addEventListener('mouseup', mouseup);
    document.addEventListener('mousemove', move);
  };

  useEffect(function () {
    return function () {
      document.removeEventListener('mouseup', mouseup);
      document.removeEventListener('mousemove', move);
    }; // eslint-disable-next-line
  }, []);
  return createElement("div", {
    style: {
      fontFamily: "BlinkMacSystemFont, \"Segoe UI\", \"Roboto\", \"Oxygen\", \"Ubuntu\", \"Cantarell\", \"Fira Sans\", \"Droid Sans\", \"Helvetica Neue\", sans-serif"
    },
    ref: rootRef
  }, createElement(Animate, {
    play: !isClose,
    end: {
      transform: 'translateY(-50px)'
    },
    delay: 0.3,
    render: function render(_ref16) {
      var style = _ref16.style;
      return createElement("button", {
        style: Object.assign({
          position: 'fixed',
          right: 0,
          top: -1,
          width: iconSize || 40,
          height: iconSize || 40,
          margin: 0,
          padding: 10,
          background: COLORS.primary,
          color: 'white',
          zIndex: Z_INDEX.top,
          fontSize: 15,
          lineHeight: '15px',
          border: 0,
          borderRadius: 0
        }, style),
        onClick: function onClick() {
          return closePanel();
        }
      }, "\u2646");
    }
  }), createElement(Animate, {
    play: isClose,
    end: {
      transform: 'translateX(102%)'
    },
    easeType: "ease-out",
    duration: 0.3,
    render: function render(_ref17) {
      var style = _ref17.style;
      return createElement("div", {
        style: Object.assign(Object.assign({
          zIndex: Z_INDEX.top,
          position: 'fixed',
          right: 0,
          width: 600,
          height: '100vh',
          background: COLORS.primary,
          display: 'grid',
          gridTemplateColumns: '3px 150px auto',
          boxShadow: '0 0 8px 3px #080808'
        }, panelPosition === 'bottom' ? {
          bottom: 0,
          width: '100%',
          height: '40%'
        } : {
          top: 0,
          width: 600 - (mouseMoveDiff || 0)
        }), style)
      }, createElement("div", {
        style: {
          cursor: 'ew-resize'
        },
        onMouseDown: onMouseDown
      }), createElement(DevToolActionPanel, {
        config: config,
        stateIndex: stateIndex,
        actions: actions,
        setStateIndex: setStateIndex
      }), createElement(DevToolStateTree, Object.assign({}, {
        setPanel: setPanel,
        panelPosition: panelPosition,
        closePanel: closePanel,
        config: config,
        actions: actions,
        isLoadPanelShow: isLoadPanelShow,
        setLoadPanel: setLoadPanel,
        state: state,
        setExpand: setExpand,
        isCollapse: isCollapse,
        setClose: setClose,
        stateIndex: stateIndex
      })));
    }
  }));
};

export { DevTool, StateMachineContext, StateMachineProvider, createStore, setStorageType, useStateMachine };